import React, { useState, useRef } from "react";
import styled from "styled-components";
import Arrow from "../../../assets/smartAnI.svg";
import ArrowDr from "../../../assets/smartAnIDr.svg";
import { FormDate } from "ui-kit/SmartForm";
import { Form, Field } from "react-final-form";
import { useSmartLink } from "../../../hooks/useSmartLink";
import { useParams } from "react-router";

const PeriodRangeDropdown: React.FC<{ open: boolean; setOpen: (v: boolean) => void, setNewData: (v: any) => void, selectedData:string, setSelectedData: (v: string) => void}> = ({ open, setOpen, setNewData, selectedData, setSelectedData }) => {
    const { getAnalyticsOverview,  getAnalyticsTimeseries, getAnalyticsCountries } = useSmartLink();
    const [selected, setSelected] = useState<string>("Last 7 Days");
    const [submenu, setSubmenu] = useState<string | null>(null);
    const formRef = useRef<any>(null);
    const { id } = useParams();

    const PRESET_MAP: Record<string, string> = {
        "Last week": "last_week",
        "This week": "this_week",
        "Last 7 days": "last_7_days",
        "Last 14 days": "last_14_days",
        "Last 30 days": "last_30_days",
        "Last 3 months": "last_3_months",
        "Last 6 months": "last_6_months",
        "Last 12 months": "last_12_months",
        "This month (April)": "this_month",
        "Last month (March)": "last_month",
        "This year (2025)": "this_year",
        "Last year (2024)": "last_year",
    };

    const onSubmit = async (values: any) => {
        try {
          let payload: any = {};
      
          if (values.from && values.to) {
            setSelected(`${values.from} - ${values.to}`);
            payload.range = { from: values.from, to: values.to }; 
          } else {
            const preset = PRESET_MAP[selectedData] || "last_week";
            setSelected(selectedData);
            payload.range = { preset }; 
          }
      
          
          const data = await getAnalyticsOverview(String(id), payload);
          const timeseries = await getAnalyticsTimeseries(String(id), payload);
          const countries = await getAnalyticsCountries(String(id), payload);
      
         
        setNewData([
            { date: "2025-10-01", clicks: 120, views: 350, unique_users: 90 },
            { date: "2025-10-02", clicks: 200, views: 420, unique_users: 130 },
            { date: "2025-10-03", clicks: 180, views: 390, unique_users: 110 },
            { date: "2025-10-04", clicks: 250, views: 500, unique_users: 160 },
            { date: "2025-10-05", clicks: 300, views: 650, unique_users: 200 },
        ]);
      
          setOpen(false);
        } catch (err) {
          console.error("Analytics fetch failed:", err);
        }
      };

    const handleSave = async () => {
        if (submenu === "Custom" && formRef.current) {
            formRef.current();
        } else {
            const preset = PRESET_MAP[selectedData] || "last_week";
            const data = await getAnalyticsOverview(String(id), { preset });
            setNewData(data)

            setOpen(false);
        }
    };


    return (
        <Wrapper>
            {open && (
                <Dropdown>
                    <div style={{ display: "flex" }}>
                        <LeftPane>
                            <SectionTitle>Period Range</SectionTitle>
                            {["Weeks", "Months", "Years", "Custom"].map((item) => (
                                <MenuItem
                                    key={item}
                                    onClick={() => setSubmenu(item)}
                                    style={{
                                        color: submenu === item ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.5)",
                                        background: submenu === item ? "rgba(226,229,255,1)" : "",
                                    }}
                                >
                                    {item} {submenu === item ? <ArrowDr /> : <Arrow />}
                                </MenuItem>
                            ))}
                        </LeftPane>

                        {submenu && (
                            <RightPane>
                                {submenu === "Weeks" && (
                                    <>
                                        {["Last week", "This week", "Last 7 days", "Last 14 days", "Last 30 days"].map((label) => (
                                            <MenuItem
                                                key={label}
                                                onClick={() => setSelectedData(label)}
                                                style={{
                                                    color: selectedData === label ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.5)",
                                                    background: selectedData === label ? "rgba(226,229,255,1)" : "",
                                                }}
                                            >
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </>
                                )}

                                {submenu === "Months" && (
                                    <>
                                        {["This month (April)", "Last month (March)", "Last 3 months", "Last 6 months", "Last 12 months"].map(
                                            (label) => (
                                                <MenuItem key={label} onClick={() => setSelectedData(label)} style={{
                                                    color: selectedData === label ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.5)",
                                                    background: selectedData === label ? "rgba(226,229,255,1)" : "",
                                                }}>
                                                    {label}
                                                </MenuItem>
                                            )
                                        )}
                                    </>
                                )}

                                {submenu === "Years" && (
                                    <>
                                        {["Last 12 months", "This year (2025)", "Last year (2024)"].map((label) => (
                                            <MenuItem key={label} onClick={() => setSelectedData(label)} style={{
                                                color: selectedData === label ? "rgba(0,0,0,1)" : "rgba(0,0,0,0.5)",
                                                background: selectedData === label ? "rgba(226,229,255,1)" : "",
                                            }}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </>
                                )}

                                {submenu === "Custom" && (
                                    <FormBox>
                                        <Form
                                            onSubmit={onSubmit}
                                            render={({ handleSubmit }) => {
                                                formRef.current = handleSubmit;
                                                return (
                                                    <form onSubmit={handleSubmit}>
                                                        <Field name="from" render={({ input }) => <FormDate {...input} placeholder="Date from" />} />
                                                        <Field name="to" render={({ input }) => <FormDate {...input} placeholder="Date to" />} />
                                                    </form>
                                                );
                                            }}
                                        />
                                    </FormBox>
                                )}
                            </RightPane>
                        )}
                    </div>

                    <Footer>
                        <ClearButton
                            onClick={() => {
                                setSelected("Last 7 Days");
                                setSelectedData("Last 7 Days");
                            }}
                        >
                            Clear
                        </ClearButton>
                        <SaveButton onClick={handleSave}>Save</SaveButton>
                    </Footer>
                </Dropdown>
            )}
        </Wrapper>
    );
};

export default PeriodRangeDropdown;

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  font-family: "SF Pro Display", sans-serif;
`;

const Trigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  min-width: 110px;
`;

const Dropdown = styled.div`
    position: absolute;
    top: -5px;
    right: 0;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 3px rgba(188, 188, 191, 0.68);
    overflow: hidden;
    z-index: 50;
    animation: fadeIn 0.15s ease;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-3px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        position: relative;
    }
`;

const LeftPane = styled.div`
  width: max-content;
  border-right: 1px solid #f3f3f3;
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 10px;
`;

const RightPane = styled.div`
  width: 200px;
  padding: 28px 10px 0 10px;
  animation: slideIn 0.2s ease;
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  padding: 18px 0 10px 18px;
  color: rgba(0, 0, 0, 1);
`;

const MenuItem = styled.div`
  width: 172px;
  height: 39px;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: rgba(226, 229, 255, 1);
    color: rgba(0, 0, 0, 1);
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 10px 16px;
  border-top: 1px solid #f3f3f3;
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  font-size: 13px;
  color: #8c8c8c;
  cursor: pointer;
`;

const SaveButton = styled.button`
  background: rgba(103, 119, 255, 1);
  color: white;
  font-size: 13px;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
`;

const FormBox = styled.div`
  padding: 10px;
`;

